export default "__VITE_ASSET__BiyCXf_C__"